import { IChannelRepository, ChannelListParams } from '../../ports/IChannelRepository';

export class ListChannelsUseCase {
  constructor(private repo: IChannelRepository) {}
  execute(params: ChannelListParams) {
    return this.repo.list(params);
  }
}
